import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { groupBy } from 'lodash';
import { DocumentService } from 'src/app/Service/document/document.service';
import { CommonService } from 'src/app/Service/Common.service';
import { ScheduleDocumentService } from 'src/app/Service/scheduledocument/scheduleDocument.service';
import { IDocumentListInputModel } from 'src/app/ViewModel/DocumentModel';


@Component({
  selector: 'app-document-cart',
  templateUrl: './document-cart.component.html',
  styleUrls: ['./document-cart.component.css']
})
export class DocumentCartComponent implements OnInit {
  public projectId!: number;
  public groupId!: number;
  public memberId!: number;
  public docType!: string;
  public documents!: any[];
  public filteredDocuments: any[] = [];
  selectedDocuments: any[] = [];
  cartDataSource: any[] = [];
  cartSelectedList: any = [];
  cartRequest = {};
  cartSelectedListCopy!: any[];
  createdByList: any[] = [];
  createdBy: string = '';
  authorizedByList: any[] = [];
  authorizedBy: string = '';

  constructor(
    public dialogRef: MatDialogRef<DocumentCartComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _docService: DocumentService,
    private _scheduleDocService: ScheduleDocumentService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.docType = 'Repository';
    this.getDocumentList();
  }

  closeDialog(data: any) {
    this.dialogRef.close(data);
  }

  tabClick(value: any) {
    this.docType = value;
    this.documents = [];
    this.createdBy = '';
    this.authorizedBy = '';
    this.getDocumentList();
  }

  async getDocumentList() {
    if (this.docType === 'Repository') {
      let inputModel: IDocumentListInputModel = {
        projectId: this.projectId,
        groupId: this.groupId,
        memberId: this.memberId,
        transType: 'MyDocuments',
        createdFromDays: 0
      }
      let documents = await this._docService.getDocumentList(inputModel).toPromise();
      this.documents = documents.map((x: any) => {
        return {
          docId: x.docId,
          documentNo: x.documentNo,
          title: x.title,
          revision: x.revision,
          authorisedByName: x.authorisedByName,
          createdByName: x.createdBy
        }
      });
    }
    else {
      let documents = await this._scheduleDocService.GetScheduleDocList({ project_Id: this.projectId, group_Id: this.groupId }).toPromise();
      this.documents = documents.map((x: any) => {
        return {
          docId: x.doc_Id,
          documentNo: x.doc_No,
          title: x.doc_Title,
          revision: x.revision_No,
          authorisedByName: x.authorized_By,
          createdByName: x.created_By
        }
      });
    }
    if (this.data != undefined && this.data.length > 0) {
      await this.setSelectedDocumentList();
    }
    this.filterDocuments();
    this.setCartValues();
    this.setAutocompleteValues();
  }

  async setSelectedDocumentList() {
    let alreadyselectedDocuments = this.data;
    this.selectedDocuments = alreadyselectedDocuments.map((x: any) => {
      let item = this.documents.find(doc => doc.docId == x.docId && doc.revision == x.revision);
      if (item != undefined) {
        return item;
      }
    });
    this.changeKeyFormat(this.documents, alreadyselectedDocuments);
  }

  changeKeyFormat(inputArr: any, alreadySelectedMembers: []) {
    let grpdSelectedMembers = groupBy(alreadySelectedMembers, 'docId');
    let outputArr: any = [];
    inputArr.forEach((eachObj: any) => {
      if (!(grpdSelectedMembers && grpdSelectedMembers[eachObj['docId']] && grpdSelectedMembers[eachObj['docId']].length)) {
        outputArr.push(eachObj);
      }
    });
    return outputArr;
  }

  setAutocompleteValues() {
    if (this.documents.length != 0) {
      let result = this.documents.map(x => x.createdByName);
      let filteredResult = result.filter((n, i) => result.indexOf(n) === i);
      this.createdByList = filteredResult.map(x => {
        return { value: x, description: x }
      });
      let result2 = this.documents.map(x => x.authorisedByName);
      let filteredResult2 = result2.filter((n, i) => result2.indexOf(n) === i);
      this.authorizedByList = filteredResult2.map(x => {
        return { value: x, description: x }
      });
    }
    else {
      this.createdByList = [];
      this.authorizedByList = [];
    }
  }

  changeCreatedBy(event: any) {
    this.createdBy = event.value != -2 ? event.value : '';
    this.filterDocuments();
  }

  changeAuthorizedBy(event: any) {
    this.authorizedBy = event.value != -2 ? event.value : '';
    this.filterDocuments();
  }

  filterDocuments() {
    if (this.createdBy != '') {
      if (this.authorizedBy != '') {
        this.filteredDocuments = this.documents.filter(x => x.authorisedByName == this.authorizedBy && x.createdByName == this.createdBy);
      }
      else {
        this.filteredDocuments = this.documents.filter(x => x.createdByName == this.createdBy);
      }
    }
    else if (this.authorizedBy != '') {
      if (this.createdBy != '') {
        this.filteredDocuments = this.documents.filter(x => x.createdByName == this.createdBy && x.authorisedByName == this.authorizedBy);
      }
      else {
        this.filteredDocuments = this.documents.filter(x => x.authorisedByName == this.authorizedBy);
      }
    }
    else {
      this.filteredDocuments = this.documents;
    }
    this.setCartValues();
  }

  setCartValues() {
    this.cartDataSource = this.removeDuplicates(this.filteredDocuments, this.selectedDocuments, 'docId');
    this.cartSelectedList = [];
    this.cartSelectedListCopy = [];
    this.selectedDocuments.forEach(eachDoc => {
      let cartValue: any = this.getAsCartSelectedValue(eachDoc.documentNo, eachDoc.title);
      this.cartSelectedList.push(cartValue);
      this.cartSelectedListCopy.push(cartValue);
    });
    this.setCartParams();
  }

  removeDuplicates(dataSource: any[], selectedArray: any[], key: string) {
    let filteredArray: any = [],
      grpdSelecetedArray = groupBy(selectedArray, key);

    dataSource.forEach((eachData: any) => {
      if (!(grpdSelecetedArray[eachData[key]] && grpdSelecetedArray[eachData[key]].length)) {
        filteredArray.push(eachData);
      }
    });
    return filteredArray;
  }

  getAsCartSelectedValue(value: string | number, text: string) {
    value = value.toString().trim();
    text = text.trim();
    let output = {
      value,
      text: value + ' - ' + text
    };
    return output;
  }

  setCartParams() {
    this.cartRequest = {
      'params': {
        'LockingType': 'P',
        'selectedCartItems': this.cartSelectedList,
      },
      'settings': {
        'mode': 'popup',
        'textField': 'title',
        'valueField': 'documentNo',
        'cartLabel': 'Choose Items',
        'minimumSelectedItemCount': 0
      },
      'dataSource': this.cartDataSource,
    }
  }

  getSelectedCartItems(event: any[]) {
    this.closeDialog(event);
  }
}
